import { Column } from 'exceljs';
import { useState, useEffect } from 'react';

import { months } from '../../common/constants';
import Leaderboard from '../../common/leaderboard';

import { IDatableColumn } from '../../common/leaderboard/column.interface';
import { ILearningGamePlayerRank } from '../../interface/learning-game-player-rank.interface';
import { getLearningGamePlayerLeaderboard } from '../../common/api/apicall';

const divisionId = '694ba9f67bb81457b9afe9d2';
export default function TvsQuiz() {
  const [data, setData] = useState<ILearningGamePlayerRank[]>([]);
  const columns: IDatableColumn[] = [
    {
      name: 'Email',
      key: 'learnerId',
    },
    {
      name: 'Name',
      key: 'name',
    },
    // {
    //   name: 'Highest Score',
    //   key: 'highestScore',
    //   type: 'number',
    // },
    {
      name: 'Date of Completion',
      key: 'completedAt',
      type: 'string',
      formatter: '',
    },
  ];

  const worksheetColumns = [
    { header: 'Email', key: 'learnerId', width: 50 } as Column,
    { header: 'Name', key: 'name', width: 50 } as Column,
    // {
    //   header: 'Highest Score',
    //   key: 'highestScore',
    //   width: 15,
    //   alignment: { horizontal: 'center' },
    // } as Column,
    { header: 'Date of Completion', key: 'completedAt', width: 15 } as Column,
  ];

  useEffect(() => {
    getLearningGamePlayerLeaderboard(divisionId, {
      includeNonPostive: true,
    //   gameOver: true,
    })
      .then((res: any[]) => {
        const filteredPlayers: any[] = [];
        res.forEach((player) => {
          player['name'] =
            (player['firstName'] || '') +
            ' ' +
            (player['lastName'] || '') +
            (player['lastname'] || '');

          if (player.highestScore) {
            player['highestScore'] = player['highestScore'];
          }

          if (player.extraDetail) {
            player['employeeId'] = player.extraDetail['employeeId'];
          }

          if (player['completedAt']) {
            const date = new Date(player['completedAt']);
            player['completedAt'] = `${date.getDate()} ${
              months[date.getMonth()]
            }, ${date.getFullYear()}`;
          }
          if (player.extraDetail) {
            filteredPlayers.push(player);
          }
        });
        setData(filteredPlayers);
      })
      .catch((error) => console.log('error: ', error));
  }, []);

  return (
    <Leaderboard
      data={data.sort(
        (a, b) =>
          new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime(),
      )}
      columns={columns}
      showIndex
      type="new"
      total={data.length}
      name="TVS Values Quiz"
      downloadable={true}
      worksheetColumns={worksheetColumns}
    />
  );
}
